import { jsonClone } from '@/utils/object-utils';

export const addObjectToUrlSearchParams = (obj: any, urlSearchParams: URLSearchParams) => {
    for (const [key, value] of Object.entries(obj)) {
        if (value === undefined) {
            continue;
        }

        if (!Array.isArray(value)) {
            urlSearchParams.set(key, String(value));
            continue;
        }

        urlSearchParams.delete(key);
        for (const val of value) {
            urlSearchParams.append(key, val);
        }
    }
};

export const objectToUrlSearchParams = (obj: any) => {
    const urlSearchParams = new URLSearchParams();

    addObjectToUrlSearchParams(obj, urlSearchParams);

    return urlSearchParams;
};

type GetSearchParams = {
    (urlSearchParams: URLSearchParams): Record<string, string | string[]>;
    <T extends string>(urlSearchParams: URLSearchParams, keys: T[]): Record<T, string | string[]>;
};

export const getSearchParamsAsObject: GetSearchParams = (
    urlSearchParams: URLSearchParams,
    keys = Array.from(urlSearchParams.keys())
) => {
    const result = {} as Record<string, string | string[] | undefined>;

    for (const key of keys) {
        if (urlSearchParams.has(key)) {
            const values = urlSearchParams.getAll(key);
            result[key] = values.length > 1 ? values : values[0] ?? undefined;
        }
    }

    return jsonClone(result) as Record<string, string | string[]>;
};
